import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCategories } from '../services/api';
import SEO from '../components/SEO';
import './CategoriesPage.css';

function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        setCategories(data || []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching categories:', error);
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="categories-page">
      <SEO
        title="Browse All Categories | Industrial Supply Marketplace"
        description="Browse our complete catalog of industrial supplies and equipment categories. Find products from verified suppliers."
        type="collection"
      />
      <div className="container">
        <h1>Browse All Categories</h1>
        <p className="categories-intro">
          Explore our complete catalog of {categories.length} product categories
        </p>
        <div className="categories-grid">
          {categories.map((category) => (
            <Link
              to={`/category/${category.id}`}
              key={category.id}
              className="category-card"
            >
              <div className="category-image">
                {category.image ? (
                  <img src={category.image} alt={category.name} loading="lazy" />
                ) : (
                  <div className="category-placeholder">
                    <span>{category.name.charAt(0)}</span>
                  </div>
                )}
              </div>
              <h3>{category.name}</h3>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoriesPage;
